import { otaUpdatesUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeadersForMultipart } from "../util/build-axios-authentication-headers";

export const createInstallationProcess = async (
  namespace: string,
  source_id: string,
  formData: FormData,
) => {
  const url = otaUpdatesUrlEnvVar();
  const headers = {
    ...buildAxiosAuthenticationHeadersForMultipart(),
  };

  try {
    const response = await axios.post(
      `${url}/api/v2/ns/${namespace}/installation-process`,
      formData,
      {
        headers: headers,
        params: {
          source_id: source_id,
        },
      },
    );

    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      throw err;
    } else {
      throw err;
    }
  }
};
